import React from "react";
import "./index.less";
import { goToNativePage } from "@/utils/common";
import { getBrowserEnv, getQueryObj } from "@/utils/tools";
import { useSearchParams } from "react-router-dom";
import { processOssImage } from "@/utils/image";

const { isMyApp, isWXApp, isXPApp } = getBrowserEnv();

const ExpiredPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const expiredTitle = searchParams.get("expiredTitle");

  const handleBackHome = () => {
    if (isXPApp || isMyApp || isWXApp) {
      goToNativePage({
        app: "xiaopeng://charging/manageNew",
        mini: "/pages/station-list/index",
      });
    } else {
      const appid = "wx081469a402310e08";
      const { version } = getQueryObj();
      window.location.href = `weixin://dl/business/?appid=${appid}&path=pages/station-list/index${version ? `&env_version=${version}` : ""}`;
    }
  };

  return (
    <div className="expired-page">
      <img
        className="expired-img"
        src={processOssImage("https://s.xiaopeng.com/xp-charge/mini/common/empty_20240408.png")}
        alt="页面已失效"
      />
      <div className="expired-title">{expiredTitle || "该链接已失效"}</div>
      <button className="expired-btn" onClick={handleBackHome}>
        返回首页
      </button>
    </div>
  );
};

export default ExpiredPage;
